import { reactive } from "vue";
import generateFlags from "./generateFlags.js";
import { defineNuxtPlugin, useRuntimeConfig, useRequestHeaders } from "#imports";
export default defineNuxtPlugin((nuxtApp) => {
  const runtimeConfig = useRuntimeConfig();
  const defaultUserAgent = runtimeConfig.public?.device?.defaultUserAgent;
  if (nuxtApp.ssrContext) {
    const headers = useRequestHeaders();
    const userAgent2 = headers["user-agent"] || defaultUserAgent || "";
    const flags2 = reactive(generateFlags(userAgent2, headers));
    return {
      provide: {
        device: flags2
      }
    };
  }
  const userAgent = navigator.userAgent || defaultUserAgent || "";
  const flags = reactive(generateFlags(userAgent));
  if (runtimeConfig.public?.device?.refreshOnResize) {
    window.addEventListener("resize", () => {
      setTimeout(() => {
        const newFlags = generateFlags(navigator.userAgent || userAgent);
        Object.entries(newFlags).forEach(([key, value]) => {
          flags[key] = value;
        });
      }, 50);
    });
  }
  return {
    provide: {
      device: flags
    }
  };
});
